import { Navigate, Route, Routes } from 'react-router-dom';
import FlightResultsPage from './pages/FlightResultsPage';
import HotelResultsPage from './pages/HotelResultsPage';
import CarResultsPage from './pages/CarResultsPage';
import PackageResultsPage from './pages/PackageResultsPage';
import CruiseResultsPage from './pages/CruiseResultsPage';
import RequestOptionPage from '../site/pages/RequestOptionPage';
import NotFoundPage from '../site/pages/NotFoundPage';
import FixedCallBar from './components/FixedCallBar';
import './flights-scoped.css';
import './components/PhoneCta.css';

const OLD_POLICY_PATHS = {
  about: '/about-us',
  support: '/contact-us',
  contact: '/contact-us',
  privacy: '/privacy-policy',
  terms: '/terms-and-conditions',
  cookies: '/cookie-policy',
  'cancellation-refund': '/cancellation-refund-policy',
  'service-fees': '/service-fees',
  'post-ticketing-fees': '/service-fees',
  'fare-disclosure': '/disclaimer',
  'price-match': '/disclaimer',
  'fulfillment-policy': '/terms-and-conditions',
  'advertiser-disclosure': '/advertiser-disclosure',
  bookings: '/contact-us',
};

/**
 * Flight search and booking pages for FlyNodex.
 * Mounted under /flight/* — sample data only, no live APIs. Results are clearly labelled as samples
 * and "Request this option" emails the choice to an advisor (nothing is booked online).
 */
export default function FlightApp() {
  return (
    <div className="fn-root">
      <Routes>
        <Route index element={<Navigate to="/" replace />} />
        <Route path="search/flights" element={<FlightResultsPage />} />
        <Route path="search/hotels" element={<HotelResultsPage />} />
        <Route path="search/cars" element={<CarResultsPage />} />
        <Route path="search/packages" element={<PackageResultsPage />} />
        <Route path="search/cruises" element={<CruiseResultsPage />} />
        <Route path="book/:type" element={<RequestOptionPage />} />
        {/* Old policy URLs (still linked from the airline help desk page) */}
        {Object.entries(OLD_POLICY_PATHS).map(([from, to]) => (
          <Route key={from} path={from} element={<Navigate to={to} replace />} />
        ))}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <FixedCallBar />
    </div>
  );
}
